import { Suit } from './Suit';

export const CARD_LOCATIONS = {
    IN_PLAYER1: 0,
    IN_AI: 1,
    IN_DECK: 2,
    IN_CRIB: 3,
    IN_TABLE: 4
};

export class Card {
    id: string;
    suit: Suit;
    number?: number;
    used?: boolean;
    value?: number;
    player?: number = 0; //0 or undefined- card in deck, 1- with player 0, 2- with player 1
    location: number = CARD_LOCATIONS.IN_DECK;

    discardIndex?: number = undefined;

    score: number; // deadwood score (used for AI)
    possibleMelds?: Card[][];

    constructor (suit: Suit, number?: number, player?: number) {
        this.id = suit+number;
        this.suit = suit;
        this.number = number;
        this.value = (number && number <= 10) ? number : 10;
        this.player = player;
    }

    // toJSON () {
    //     return `${this.suit}-${this.number}`;
    // }
}


// WEBPACK FOOTER //
// ./src/playing-cards/Card.ts